/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Route, BrowserRouter as Router, Routes, useLocation, useNavigate } from "react-router-dom";
import { fetchMyAccess } from "./api/access";
import { defaultAxiosInstance } from "./api/defaultInstance";
import ProtectedRoute from "./component/protect/ProtectedRoute";
import { UserProvider, useUser } from "./context/UserContext";
import { AccessProvider, useAccess } from "./context/AccessContext";
import AdAddKakaoFriendManagement from "./pages/AdAddKakaoFriendManagement";
import AdBlogManagement from "./pages/AdBlogManagement";
import AdExperienceReviewerManagement from "./pages/AdExperienceReviewerManagement";
import AdFollowOnDaangnManagement from "./pages/AdFollowOnDaangnManagement";
import AdBizProfileReviewManagement from "./pages/AdBizProfileReviewManagement";
import AdLogoDesignManagement from "./pages/AdLogoDesignManagement";
import AdManagement from "./pages/AdManagement";
import AdminCampaignManagement from "./pages/AdminCampaignManagement";
import AdMomCafeCarrotManagement from "./pages/AdMomCafeCarrotManagement";
import AdProductDetail from "./pages/AdProductDetail";
import AdProductManagement from "./pages/AdProductManagement";
import AdProductWrite from "./pages/AdProductWrite";
import AdReviewDelete from "./pages/AdReviewDelete";
import AdReviewManagement from "./pages/AdReviewManagement";
import AdSettlementManagement from "./pages/AdSettlementManagement";
import AdShoppingManagement from "./pages/AdShoppingManagement";
import AdPartnerCafeManagement from "./pages/AdPartnerCafeManagement";
import AdTvAdManagement from "./pages/AdTvAdManagement";
import TenantBrokerageFeeManagement from "./pages/TenantBrokerageFeeManagement";
import AdVerification from "./pages/AdVerification";
import BrandingPackageManagement from "./pages/BrandingPackageManagement";
import CampaignHistory from "./pages/CampaignHistory";
import ConsumptionVolumeCheck from "./pages/ConsumptionVolumeCheck";
import Dashboard from "./pages/Dashboard";
import InvoiceManagement from "./pages/InvoiceManagement";
import Login from "./pages/Login";
import NewsReleaseCategoryDetail from "./pages/NewsReleaseCategoryDetail";
import NewsReleaseCategoryManagement from "./pages/NewsReleaseCategoryManagement";
import NewsReleaseCategoryWrite from "./pages/NewsReleaseCategoryWrite";
import NewsReleaseManagement from "./pages/NewsReleaseManagement";
import PasswordChange from "./pages/PasswordChange";
import ReferralManagement from "./pages/ReferralManagement";
import RevenueAnalysis from "./pages/RevenueAnalysis";
import RewardUserList from "./pages/RewardUserList";
import SettlementManagement from "./pages/SettlementManagement";
import TrashCampaignManagement from "./pages/TrashCampaignManagement";
import UserCreate from "./pages/UserCreate";
import UserDetail from "./pages/UserDetail";
import UserList from "./pages/UserList";
import UserReferralDetail from "./pages/UserReferralDetail";
import WalletDashboard from "./pages/WalletDashboard";
import WalletChargeManagement from "./pages/WalletChargeManagement";
import WalletPaymentManagement from "./pages/WalletPaymentManagement";
import WalletCancelManagement from "./pages/WalletCancelManagement";
import WalletWithdrawalManagement from "./pages/WalletWithdrawalManagement";
import WalletUserDetail from "./pages/WalletUserDetail";
import WalletPolicy from "./pages/WalletPolicy";
import BlogAnalysisRegistry from "./pages/BlogAnalysisRegistry";
import NoAccess from "./pages/NoAccess";
import AccessPermissionView from "./pages/access/AccessPermissionView";
import AccessAdminView from "./pages/access/AccessAdminView";
import AccessRoles from "./pages/access/AccessRoles";
import AccessAuditLogs from "./pages/access/AccessAuditLogs";
import { NO_ACCESS_PATH, resolvePostLoginPath } from "./utils/routeAccess";

// AutoLogin 컴포넌트
const AutoLogin = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const { setUserInfo } = useUser(); // Context에서 setUserInfo 가져오기
  const { refreshAccess } = useAccess();

  const autoLogin = async () => {
    try {
      setLoading(true);
      const response = await defaultAxiosInstance.post(
        "/admin/login/auto",
        {},
        {
          withCredentials: true, // 쿠키 기반 인증이 필요한 경우
        },
      );
      const userInfo = response.data;
      setUserInfo(userInfo);
      // 로그인 직후 권한 조회 (R-FE-01)
      const access = await refreshAccess(userInfo);

      console.log("Auto-login 성공:", response.data);
      // 로그인 화면(/)이거나 권한 없는 화면이면 권한이 있는 첫 메뉴로, 아니면 현재 화면 유지(새로고침 대응)
      const target = resolvePostLoginPath(location.pathname, access.hasPermission);
      if (target) navigate(target);
    } catch (err) {
      console.error("Auto-login 실패:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    autoLogin();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return children;
};

function App() {
  return (
    <UserProvider>
      <AccessProvider fetchMe={fetchMyAccess}>
      <Router>
        <AutoLogin>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route
              path={NO_ACCESS_PATH}
              element={
                <ProtectedRoute>
                  <NoAccess />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/blog-analysis-registry"
              element={
                <ProtectedRoute>
                  <BlogAnalysisRegistry />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute>
                  <UserList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users/detail/:userId"
              element={
                <ProtectedRoute>
                  <UserDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users/create"
              element={
                <ProtectedRoute>
                  <UserCreate />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users/password"
              element={
                <ProtectedRoute>
                  <PasswordChange />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rewards/users"
              element={
                <ProtectedRoute>
                  <RewardUserList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rewards/settlement"
              element={
                <ProtectedRoute>
                  <SettlementManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rewards/users/detail"
              element={
                <ProtectedRoute>
                  <UserReferralDetail />
                </ProtectedRoute>
              }
            />{" "}
            {/* ✅ 상세페이지 라우팅 */}
            <Route
              path="/ads/campaign/list"
              element={
                <ProtectedRoute>
                  <AdManagement />
                </ProtectedRoute>
              }
            />{" "}
            {/* ✅ 광고 신청 목록 라우팅 */}
            <Route
              path="/ads/campaign/trash"
              element={
                <ProtectedRoute>
                  <TrashCampaignManagement />
                </ProtectedRoute>
              }
            />{" "}
            {/* ✅ 휴지통 캠페인 관리 */}
            <Route
              path="/ads/campaign/verify"
              element={
                <ProtectedRoute>
                  <AdVerification />
                </ProtectedRoute>
              }
            />{" "}
            {/* ✅ 광고 검수 라우팅 */}
            <Route
              path="/ads/products"
              element={
                <ProtectedRoute>
                  <AdProductManagement />
                </ProtectedRoute>
              }
            />{" "}
            {/* ✅ 상세페이지 라우팅 */}
            <Route
              path="/ads/product/write"
              element={
                <ProtectedRoute>
                  <AdProductWrite />
                </ProtectedRoute>
              }
            />{" "}
            {/* 추가된 경로 */}
            <Route
              path="/ads/product/detail"
              element={
                <ProtectedRoute>
                  <AdProductDetail />
                </ProtectedRoute>
              }
            />{" "}
            {/* 추가된 경로 */}
            <Route
              path="/ads/invoice"
              element={
                <ProtectedRoute>
                  <InvoiceManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/reviewDelete/list"
              element={
                <ProtectedRoute>
                  <AdReviewDelete />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/newsRelease/categories"
              element={
                <ProtectedRoute>
                  <NewsReleaseCategoryManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/newsRelease/category/write"
              element={
                <ProtectedRoute>
                  <NewsReleaseCategoryWrite />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/newsRelease/category/detail"
              element={
                <ProtectedRoute>
                  <NewsReleaseCategoryDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/newsRelease/management"
              element={
                <ProtectedRoute>
                  <NewsReleaseManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/blog/management"
              element={
                <ProtectedRoute>
                  <AdBlogManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/momcafe-carrot/management"
              element={
                <ProtectedRoute>
                  <AdMomCafeCarrotManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/experience-reviewer/management"
              element={
                <ProtectedRoute>
                  <AdExperienceReviewerManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/branding-package/management"
              element={
                <ProtectedRoute>
                  <BrandingPackageManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/logo-design/management"
              element={
                <ProtectedRoute>
                  <AdLogoDesignManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/add-kakao-friend/management"
              element={
                <ProtectedRoute>
                  <AdAddKakaoFriendManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/follow-on-daangn/management"
              element={
                <ProtectedRoute>
                  <AdFollowOnDaangnManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/biz-profile/management"
              element={
                <ProtectedRoute>
                  <AdBizProfileReviewManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/review/management"
              element={
                <ProtectedRoute>
                  <AdReviewManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/shopping/management"
              element={
                <ProtectedRoute>
                  <AdShoppingManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/partner-cafe/management"
              element={
                <ProtectedRoute>
                  <AdPartnerCafeManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/tv-ad/management"
              element={
                <ProtectedRoute>
                  <AdTvAdManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/tenant-brokerage-fee/management"
              element={
                <ProtectedRoute>
                  <TenantBrokerageFeeManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/revenue-analysis"
              element={
                <ProtectedRoute>
                  <RevenueAnalysis />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/settlement/referral-management"
              element={
                <ProtectedRoute>
                  <ReferralManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/settlement/campaign-history"
              element={
                <ProtectedRoute>
                  <CampaignHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/settlement/settlement-management"
              element={
                <ProtectedRoute>
                  <AdSettlementManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reward-admin/campaign-management"
              element={
                <ProtectedRoute>
                  <AdminCampaignManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reward-admin/consumption-volume"
              element={
                <ProtectedRoute>
                  <ConsumptionVolumeCheck />
                </ProtectedRoute>
              }
            />
            <Route
              path="/wallet/dashboard"
              element={
                <ProtectedRoute>
                  <WalletDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/wallet/charge"
              element={
                <ProtectedRoute>
                  <WalletChargeManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/wallet/payment"
              element={
                <ProtectedRoute>
                  <WalletPaymentManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/wallet/cancel"
              element={
                <ProtectedRoute>
                  <WalletCancelManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/wallet/withdrawal"
              element={
                <ProtectedRoute>
                  <WalletWithdrawalManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/wallet/user"
              element={
                <ProtectedRoute>
                  <WalletUserDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/wallet/user/:userId"
              element={
                <ProtectedRoute>
                  <WalletUserDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/wallet/policy"
              element={
                <ProtectedRoute>
                  <WalletPolicy />
                </ProtectedRoute>
              }
            />
            <Route
              path="/access/permissions"
              element={
                <ProtectedRoute>
                  <AccessPermissionView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/access/admins"
              element={
                <ProtectedRoute>
                  <AccessAdminView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/access/roles"
              element={
                <ProtectedRoute>
                  <AccessRoles />
                </ProtectedRoute>
              }
            />
            <Route
              path="/access/audit-logs"
              element={
                <ProtectedRoute>
                  <AccessAuditLogs />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AutoLogin>
      </Router>
      </AccessProvider>
    </UserProvider>
  );
}

export default App;
